import { Table } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { type AudiCalculationModuleSpecsFragment } from '../../../../../api/fragments/AudiCalculationModuleSpecs';
import AudiCalculationSettingsAction from './AudiCalculationSettingsAction';

export type AudiCalculationSettingsTableProps = {
    module: AudiCalculationModuleSpecsFragment;
};

export type AudiCalculationSettingSpecs = AudiCalculationModuleSpecsFragment['audiCalculationSettings'][number];

const AudiCalculationSettingsTable = ({ module }: AudiCalculationSettingsTableProps) => {
    const { t } = useTranslation(['audiCalculationModuleDetails']);

    const renderActions = useCallback(
        (record: AudiCalculationSettingSpecs) => (
            <AudiCalculationSettingsAction module={module} setting={record} showUpdate />
        ),
        [module]
    );

    return (
        <Table dataSource={module.audiCalculationSettings} rowKey="id">
            <Table.Column
                key="displayName"
                dataIndex="displayName"
                title={t('audiCalculationModuleDetails:settings.columns.displayName')}
            />
            <Table.Column
                key="identifier"
                dataIndex="identifier"
                title={t('audiCalculationModuleDetails:settings.columns.settingId')}
            />
            <Table.Column
                key="actions"
                align="center"
                render={renderActions}
                title={t('audiCalculationModuleDetails:settings.columns.actions')}
                width={100}
            />
        </Table>
    );
};

export default AudiCalculationSettingsTable;
